module.exports = __webpack_public_path__ + "img/details_logo.aa030bcc.svg";